import { get } from '@/api/request';

function fetchApps(params) {
  return get('/apps', params);
}

function fetchSingleApp({ id, params = {} }) {
  return get(`/apps/${id}`, params);
}

export default {
  fetchApps,
  fetchSingleApp,
};



// WEBPACK FOOTER //
// ./src/store/modules/app/api.js